import React, { useRef } from 'react';
import { Dialog } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { Maximize2, X } from 'lucide-react';
import { useOperatorAssistant } from './OperatorAssistantContext';
import OperatorAssistantWorkspace from './OperatorAssistantWorkspace';

export default function OperatorAssistantDrawer() {
  const assistant = useOperatorAssistant();
  const closeRef = useRef<HTMLButtonElement>(null);
  if (!assistant.eligible) return null;
  return <Dialog open={assistant.drawerOpen} onClose={assistant.closeDrawer} initialFocus={closeRef} className="assistant-dialog">
    <div className="assistant-dialog-backdrop" aria-hidden="true" />
    <div className="assistant-dialog-position"><Dialog.Panel className="assistant-drawer"><header className="assistant-drawer-heading"><Dialog.Title>MODAL Assistant</Dialog.Title><div><Link to="/admin/assistant" onClick={assistant.closeDrawer} title="Open full assistant workspace" aria-label="Open full assistant workspace"><Maximize2 size={18} aria-hidden="true" /></Link><button ref={closeRef} type="button" title="Close MODAL Assistant" aria-label="Close MODAL Assistant" onClick={assistant.closeDrawer}><X size={20} aria-hidden="true" /></button></div></header><OperatorAssistantWorkspace compact /></Dialog.Panel></div>
  </Dialog>;
}
